export default __webpack_public_path__ + "images/assets/8db824f75c251420e1db6fb34a9bf458.svg";